export default {
  CODEPUSH_KEY_ANDROID: '',
  CODEPUSH_KEY_IOS: ''
};
